// dependencies
import { List, fromJS } from "immutable";

export const formatAddEasyAdd = (formWithUpdates, savedForm) => {
	const mergedForm = savedForm.merge(fromJS(formWithUpdates));
	const mutatedUpdates = mergedForm.withMutations((mutable) => {
		const dateType = mutable.get("due_date_types");

		if (mutable.has("author_due_date")) {
			const authorsDueDate = mutable.get("author_due_date");
			if (dateType === "static") {
				mutable.set("author_due_date", authorsDueDate ? authorsDueDate.toISOString() : null);
			} else {
				mutable.set("author_due_date", authorsDueDate);
			}
		}
		if (mutable.has("signer_due_date")) {
			const signersDueDate = mutable.get("signer_due_date");
			if (dateType === "static") {
				mutable.set("signer_due_date", signersDueDate ? signersDueDate.toISOString() : null);
			} else {
				mutable.set("signer_due_date", signersDueDate);
			}
		}
		if (mutable.has("who_signs_off")) {
			mutable.set(
				"who_signs_off",
				mutable.get("who_signs_off", List()).map((employee) => ({
					id: employee.get("id"),
					name: employee.get("name"),
				}))
			);
		}
	});

	const formObject = {
		formID: mergedForm.getIn(["formObject", "_id"], null),
		who_can_add_form: {
			any_employee: mergedForm.getIn(["who_can_add_form", "any_employee"]),
			subject: mergedForm.getIn(["who_can_add_form", "subject"]),
			manager_or_chain_of_command: mergedForm.getIn(["who_can_add_form", "manager_or_chain_of_command"]),
			admin_or_group_admin: mergedForm.getIn(["who_can_add_form", "admin_or_group_admin"]),
		},
		subject_employee_choose_author: mergedForm.get("subject_employee_choose_author"),
		who_signs_off: mutatedUpdates.get("who_signs_off").toJS(),
		due_date_types: mergedForm.get("due_date_types"),
		author_due_date: mutatedUpdates.get("author_due_date"),
		signer_due_date: mutatedUpdates.get("signer_due_date"),
		visibility: mergedForm.get("visibility"),
		allow_comments: mergedForm.get("allow_comments"),
		redact: mergedForm.get("redact"),
		created_at: "",
		modified_at: "",
		deleted_at: "",
		is_active: mergedForm.get("is_active"),
		requiresApproval: mergedForm.get("requiresApproval"),
	};
	return formObject;
};

export const formatEasyAddConfig = (value, startDate, type) => ({
	formID: value.get("id"),
	formObject: { _id: value.get("id"), name: value.get("name") },
	who_can_add_form: {
		any_employee: true,
		subject: false,
		manager_or_chain_of_command: false,
		admin_or_group_admin: false,
	},
	subject_employee_choose_author: "",
	who_signs_off: [],
	author_due_date: startDate.clone(),
	signer_due_date: startDate.clone().add(1, "days"),
	due_date_types: "static",
	redact: false,
	visibility: false,
	allow_comments: false,
	is_active: true,
	requiresApproval: null,
	isNewForm: true,
	unsaved: type === "edit",
}); // set unsaved as true only if adding easy add in edit review cycle

const getWhoCanAdd = (whoCanAddObj, subjectEmployeeChooseAuthor) => {
	let whoCanAdd = "";
	const whoCanAddKeys = Object.keys(whoCanAddObj);
	whoCanAddKeys.forEach((item) => {
		if (whoCanAddObj[item] === true) {
			whoCanAdd = item;
		}
	});
	// If "Who can add this form" is "Subject" then there is an additional
	// field "subject type" to specify how to determine the author - "self" for
	// self authored or "Any Employee" to select the author at the time the
	// form gets created
	if (subjectEmployeeChooseAuthor) {
		whoCanAdd = whoCanAdd + subjectEmployeeChooseAuthor;
	}
	return whoCanAdd;
};

export const checkDuplicateEasyAdd = (formObject, easyAddForms, index) => {
	const formToAddID = formObject.formID;
	const formToAddWhoCanAdd = getWhoCanAdd(formObject.who_can_add_form, formObject.subject_employee_choose_author);

	for (let i = 0; i < easyAddForms.size; i += 1) {
		// only check for duplicates on forms that are not the one being
		// added/ updated
		if (index !== i) {
			const formID = easyAddForms.getIn([i, "formObject", "_id"]);
			const whoCanAdd = getWhoCanAdd(
				easyAddForms.getIn([i, "who_can_add_form"]).toJS(),
				easyAddForms.getIn([i, "subject_employee_choose_author"])
			);
			if (formID === formToAddID && formToAddWhoCanAdd === whoCanAdd) {
				return true;
			}
		}
	}
	return false;
};
